import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { getUserDetails, updateUser } from '../actions/userActions'
import { USER_UPDATE_RESET } from '../constants/userConstants'
import { EMPLOYEE_PERMISSION_OPTIONS } from '../constants/employeePermissions.js'

const UserEditScreen = () => {
  const params = useParams()
  const userId = params.id

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [permissions, setPermissions] = useState([])
  const [isDisabled, setIsDisabled] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userDetails = useSelector((state) => state.userDetails)
  const { loading, error, user } = userDetails

  const userUpdate = useSelector((state) => state.userUpdate)
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate
  } = userUpdate

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin
  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  useEffect(() => {
    if (!ownerInfo?.isOwner) {
      navigate(userInfo ? '/pos' : '/login')
      return
    }

    if (successUpdate) {
      dispatch({ type: USER_UPDATE_RESET })
      navigate('/admin/userlist')
      return
    }

    if (!user || !user.name || user._id !== userId) {
      dispatch(getUserDetails(userId))
    } else {
      setName(user.name)
      setEmail(user.email)
      setPermissions(user.permissions || [])
      setIsDisabled(user.isDisabled)
    }
  }, [dispatch, navigate, userId, user, userInfo, ownerInfo, successUpdate])

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(updateUser({ _id: userId, name, email, permissions, isDisabled }))
  }

  const togglePermission = (permission) => {
    setPermissions((currentPermissions) =>
      currentPermissions.includes(permission) ?
        currentPermissions.filter((current) => current !== permission)
      : [...currentPermissions, permission]
    )
  }

  return (
    <>
      <Link to='/admin/userlist' className='btn btn-outline-primary my-2'>
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit User</h1>
        <Link
          to={`/admin/user/${userId}/password`}
          className='btn btn-outline-secondary btn-sm mb-2'
        >
          Reset Password
        </Link>
        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
        {loading ?
          <Loader />
        : error ?
          <Message variant='danger'>{error}</Message>
        : <Form onSubmit={submitHandler}>
            <Form.Group className='mb-2' controlId='name'>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter name'
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group className='mb-2' controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group className='mb-2' controlId='employeePermissions'>
              <Form.Label>Additional permissions</Form.Label>
              {EMPLOYEE_PERMISSION_OPTIONS.map(({ value, label }) => (
                <Form.Check
                  key={value}
                  type='checkbox'
                  id={`permission-${value}`}
                  label={label}
                  checked={permissions.includes(value)}
                  onChange={() => togglePermission(value)}
                />
              ))}
            </Form.Group>

            <Form.Group className='mb-2' controlId='isdisabled'>
              <Form.Check
                type='checkbox'
                label='Is Disabled'
                checked={isDisabled}
                onChange={(e) => setIsDisabled(e.target.checked)}
              ></Form.Check>
            </Form.Group>
            <Button type='submit' variant='outline-primary' className='mt-3'>
              Update
            </Button>
          </Form>
        }
      </FormContainer>
    </>
  )
}

export default UserEditScreen
